import _slicedToArray from "E:/code/nkyOrder/trunk/vantCommon/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { decrypt } from '../../assets/utils/cryptoUtil.js';
import { checkWeChatMessage, getConsentFormCount as _getConsentFormCount, getWeChatMessage as _getWeChatMessage, getWeChatMessageCount as _getWeChatMessageCount } from "@/api/module";
export default {
  name: "index",
  data: function data() {
    return {
      active: 1,
      quests: [],
      filterShow: false,
      show: false,
      startDate: null,
      endDate: null,
      iconColor: '#000000',
      screenTimeShow: 1,
      task: 0,
      // 待办任务数量
      messageCount: 0 // 消息数量

    };
  },
  created: function created() {
    this.init();
  },
  filters: {
    typeFilter: function typeFilter(type) {
      if (type && type != '') {
        switch (type) {
          case '2':
            return '公告通知';

          case '3':
            return '健康科普';
        }
      } else {
        return "";
      }
    }
  },
  methods: {
    init: function init() {
      this.getConsentFormCount();
      this.getWeChatMessageCount();
      this.getWeChatMessage();
    },
    getWeChatMessageCount: function getWeChatMessageCount() {
      _getWeChatMessageCount().then(function (res) {
        localStorage.setItem("messageCount", res.data);
      });
    },
    getWeChatMessage: function getWeChatMessage() {
      var _this = this;

      _getWeChatMessage().then(function (res) {
        _this.quests = res.data;
      });
    },
    //2025-2-26 ZLS  新增获取消息的数量
    getConsentFormCount: function getConsentFormCount() {
      var _this2 = this;

      var loginuser = JSON.parse(localStorage.getItem("loginuser"));

      if (loginuser == null) {
        return;
      }

      var param = {
        patientid: loginuser.patientid
      };

      _getConsentFormCount(param).then(function (res) {
        if (res.code == 200 && res.data > 0) {
          _this2.task = res.data;
        }
      });
    },
    toDetail: function toDetail(index) {
      this.quests[index].omitFlag = !this.quests[index].omitFlag;
      this.$router.push({
        name: 'messageDetail',
        query: {
          item: this.quests[index].id
        }
      });
    },
    filter: function filter() {
      this.filterShow = true;
    },
    formatDate: function formatDate(date) {
      return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
    },
    onConfirm: function onConfirm(date) {
      var _date = _slicedToArray(date, 2),
          start = _date[0],
          end = _date[1];

      this.screenTimeShow = 0;
      this.show = false;
      this.startDate = "".concat(this.formatDate(start));
      this.endDate = "".concat(this.formatDate(end));
    },
    filterClose: function filterClose(item) {
      this.filterShow = false;

      if (item == 0) {
        this.screenTimeShow = 1;
        this.startDate = null;
        this.endDate = null;
        this.iconColor = '#000000';
        this.getConsentFormList();
      } else {
        this.iconColor = '#1989fa';
        this.getConsentFormList();
      }
    },
    screenTime: function screenTime(item) {
      this.screenTimeShow = item; // 输出结果

      this.startDate = this.getTime(item);
      this.endDate = this.getTime(0);
    },
    getTime: function getTime(item) {
      // 获取当前时间
      var currentDate = new Date(); // 往后推一年

      var formattedDate = currentDate.getFullYear() - item + '-' + (currentDate.getMonth() + 1).toString().padStart(2, '0') + '-' + currentDate.getDate().toString().padStart(2, '0');
      return formattedDate;
    },
    toHome: function toHome() {
      this.$router.push({
        name: 'home'
      });
    },
    toUserinfo: function toUserinfo() {
      this.$router.push({
        name: 'userinfo'
      });
    },
    toOrders: function toOrders() {
      this.$router.push({
        name: 'orders'
      });
    },
    toTask: function toTask() {
      this.$router.push({
        name: 'letterConsent'
      });
    }
  }
};